/* eslint-disable @typescript-eslint/method-signature-style */
import { InjectionToken } from '@angular/core';
import { SessionPreference } from '@sondermind/utilities/models-session';

/**
 * @deprecated Obsolete - supports legacy native mobile application
 * This file to be removed whenever the legacy native mobile app is retired.
 */

/** @deprecated Obsolete - supports legacy native mobile application */
export type NativePushServiceType =
  'apn' | 'fcm' | 'gcm';

/** @deprecated Obsolete - supports legacy native mobile application */
export type NativePushDeviceType =
  'phone' | 'tablet';

/** @deprecated Obsolete - supports legacy native mobile application */
export type NativePushAppType =
  'client' | 'therapist';

/** @deprecated Obsolete - supports legacy native mobile application */
export interface NativeUser {
  firstName: string;
  lastName: string;
}

/** @deprecated Obsolete - supports legacy native mobile application */
declare const sondermind_native: SondermindNative | undefined;

/** @deprecated Obsolete - supports legacy native mobile application
 *
 * *Use [getNativeAppContextObject](../../../../../libs/native-app-interface/src/lib/services/native-app-context.helpers.ts) instead*
*/
export function getNativeApp() {
  return sondermind_native;
}

/** @deprecated Obsolete - supports legacy native mobile application
 *
 * *Use [isHostedInNativeApp](../../../../../libs/native-app-interface/src/lib/services/native-app-context.helpers.ts) instead*
*/
export function isLegacyNativeApp() {
  return typeof sondermind_native !== 'undefined'
    && !(sondermind_native as { getAppVersion?: () => string; }).getAppVersion;
}

/** @deprecated Obsolete - supports legacy native mobile application
 *
 * *Refer to [NativeAppContext](../../../../../libs/native-app-interface/src/lib/models/native-app-context.model.ts) instead*
*/
export interface SondermindNative {

  /**
     Called by the application when a user authentication has completed.
     Once this has occurred, authenticated API requests can be made.
  */
  onUserAuthenticated();

  /**
     Called by the application when a user authentication has been removed.
     After this has occurred, no authenticated API requests can be made.
  */
  onUserUnauthenticated();

  /**
   * Called when the video overlay is opened.
   */
  onAvBtnLaunchClicked(token: string, roomName: string, displayName: string);

  /**
   * Called when the AV test panel is opened.
   */
  onAVBtnTestClicked();

  /**
   * Called when a PSL session has been booked.
   * @param providerId The ID of the provider with whom the session was booked
   * @param requestedTime The requested date/time for the session
   * @param sessionType The type of session booked ('inPerson' or 'video')
   */
  onPslBookedASession(providerId: number, requestedTime: Date, sessionType: SessionPreference): void;

}

/** @deprecated Obsolete - supports legacy native mobile application */
export interface SondermindWebapp {

  /**
     Given the parameters, make an authenticated API request to the server to
     associate the given push binding to the user.

     @param type - the type of binding (gcm, fcm, apn)
     @param address - the binding to register (from the push provider)
     @param nickname - a human nickname for the device ("Jon's Pixel")
     @param device - phone or tablet, combined with type for a system icon in UI
  */
  associatePushDevice(
    device: NativePushDeviceType,
    nickname: string,
    type: NativePushServiceType,
    address: string,
  );

  /**
   * Called by the native app to indicate closure of the video overlay.
   *
   * @memberof SondermindWebapp
   */
  onVideoOverlayClosed();

  /**
   * Used by the web app to wait for the closure of video from the native app.
   *
   * @memberof SondermindWebapp
   */
  videoOverlayWait: () => Promise<void>;

}

/** @deprecated Obsolete - supports legacy native mobile application */
export const SONDERMIND_WEB_APP = new InjectionToken<SondermindWebapp>('portal implementation of web app binding');
